module.exports = __webpack_public_path__ + "assets/img/Type E (65).49cebced.jpg";